import React, { useState, useEffect } from 'react';
import { ListItem } from '../atoms/listitem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import variables from '../atoms/variables.json';
import { TextInput } from '../atoms/textinput';
import moment from 'moment';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
// import { tenantActions, alertActions } from '_actions';
import ToolTip from '../atoms/ToolTip';
import { tenantActions, alertActions } from '../../redux/tenant.actions';
import ProgressCircle from "./components/ProgressCircle"
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import DialogButton from '@material-ui/core/Button';
// import HOLDING_ICON from './../../../assets/svgIcons/OpenFlo/HoldingDeposit.svg';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import {
  CardWrapper,
  TlyfeSelector,
  LineSeperator,
  Heading,
  SubHeading,
  TlyfeButtonWrapper,
  FormContainer,
  RowContainer,
  TextBox,
} from './style';
import { CardBox } from '../atoms/card';
import { Button } from '../atoms/button';
import BackComponent from '../atoms/backComponent';
import { useDispatch, useSelector } from 'react-redux';
import { getHoldingDeposite, getHoldingDepositStatusData1, showErrorToast, showSuccesToast } from '../helpers';
import BottomButton from '../atoms/bottomButton';
import { Otp } from '../atoms/otp';
import OpenFlowModal from '../atoms/modal';
import SaveandContinueModal from '../atoms/SaveandContinueModal';
import Container from '../atoms/Container/Container';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';
import getPlatformType from '../../../../helpers/helpers';
import { TenantService } from '../../redux/tenant.service';
import HoldingStatusTable from './HoldingStatusTable';
import InfowaningBox from './components/infowaningBox';
import BankAccountComponent from './components/bankAccountComp';
import Colors from '../../../../constants/Colors';
import HoldingDepositCard from './components/HoldingDepositCard';
import { Feather } from '@expo/vector-icons';
import HoldingTerms from './modals/HoldingTerms';
const layoutType = getPlatformType();

const HoldingDeposit = (props) => {
  const [holding_terms, setHoldingTerms] = React.useState("A holding deposit or “holding fee” is a financial sum that tenant(s) pay as confirmation of their intent to proceed with an application to rent a property. The deposit secures the property for tenant(s).");
  const [holding_terms_added, setHoldingTermsAdded] = React.useState(null);
  const [Accounts, setAccounts] = React.useState([]);
  const [openAccountModal, setAccountModal] = React.useState(false);
  const [isValidated, setIsValidated] = React.useState(false);
  const [collectDeposit, setcollectDeposit] = React.useState(false);
  const [showSuccessModal, setSuccessModal] = React.useState(false);
  const [showExecutionCheckModal, setShowExecutionCheckModal] = useState(false);
  const [selectedTenants, setSelectedTenants] = useState([]);

  const [account_id, setAccount_id] = React.useState('');
  const [sortCode, setsortCode] = React.useState('');
  const [accountName, setAccountName] = React.useState('');
  const [payeeRef, setPayeeRef] = React.useState('');
  const [tenants, setTeanats] = React.useState([]);
  const [rental_amount, setRentalAmount] = React.useState(null);
  const [rental_frequency, setRentalFrequency] = React.useState('monthly');
  const [newAccountName, setnewAccountName] = React.useState('');
  const [newAccountSortCode, setnewAccountSortCode] = React.useState('');
  const [newAccountNumber, setnewAccountNumber] = React.useState('');


  const [tenancy_start_date, setTenanctStartDate] = React.useState(null);
  const [holding_amount, setHolding_deposit_amount] = React.useState(null);

  const [isHoldingDepositSelected, setHoldingDepositSelected] = React.useState(true);

  const [selectedAccount, setselectedAccount] = React.useState('');
  const [selectedBranch, setselectedBranch] = React.useState('');

  const [newAccAdded, setNewAccAdded] = React.useState('');
  const [accountButtonText, setAccountButtonText] = React.useState('Add Account');
  const [flowId, setFlowId] = React.useState(null);
  const [editAccounts, setEditAccounts] = React.useState(false);
  const [dateDepositReceived, setdateDepositReceived] = React.useState(null);
  const dispatch = useDispatch();
  const modalGlobalObject = useSelector((state) => state?.tenant?.flowIdInfo);

  const bankAccounts = useSelector((state) => state?.tenant?.branchBankAccounts);

  const branches = useSelector((state) => state?.tenant?.companyBranches);

  const [modalState, setModalState] = React.useState({
    send_to_tenant: true,
  });

  const [holdingDepositCollection, setHoldingDepositCollection] = useState(null);

  useEffect(() => {
    if (modalGlobalObject) {
      setModalState({
        send_to_tenant: modalGlobalObject.send_to_tenant,
      });
    }
  }, [modalGlobalObject]);


  useEffect(() => {
    if (props?.route?.params?.id) {
      setFlowId(props?.route?.params?.id);
      fetchFlows()
      dispatch(tenantActions.getBranchBankAccounts());
      dispatch(tenantActions.getCompanyBranches());
    }

  }, [props?.route?.params?.id]);
  const fetchFlows = () => {
    dispatch(tenantActions.getFlowInfo(props?.route?.params?.id));
  }
  const holdingDepositeData = useSelector((state) => state?.tenant?.flowIdInfo?.open_flow_holding_deposit);

  const userData = useSelector((state) => state.users);

  useEffect(() => {
    setHoldingTermsAdded(holdingDepositeData?.holding_deposit_text)
    setHoldingDepositSelected(holdingDepositeData?.is_holding_deposit_selected);

    const leadCollection = holdingDepositeData?.holding_deposit_collection_from_lead_tenant ?? modalGlobalObject?.holding_deposit_collection_from_lead_tenant ?? false;
    setHoldingDepositCollection(leadCollection);
    setcollectDeposit(leadCollection);

    if (holdingDepositeData?.holding_deposit_text) {
      setHoldingTermsAdded(holdingDepositeData.holding_deposit_text);
    }

    if (holdingDepositeData?.tenants && holdingDepositeData?.tenants.length) {
      setTeanats(modalGlobalObject?.tenants);
    }
    if (modalGlobalObject?.open_flow_rental_offer?.rental_frequency) {
      setRentalFrequency(modalGlobalObject?.open_flow_rental_offer?.rental_frequency);
    }

    if (modalGlobalObject?.open_flow_rental_offer?.tenancy_start_date) {
      setTenanctStartDate(moment(modalGlobalObject?.open_flow_rental_offer?.tenancy_start_date).format('YYYY-MM-DD'));
    }
    if (modalGlobalObject?.open_flow_rental_offer?.rental_amount) {
      setRentalAmount(modalGlobalObject?.open_flow_rental_offer?.rental_amount);
    }
    if (modalGlobalObject?.payee_ref) {
      setPayeeRef(modalGlobalObject?.payee_ref);
    }
    if (holdingDepositeData?.holding_terms) {
      setHoldingTerms(holdingDepositeData?.holding_terms);
    }
    if (holdingDepositeData?.holding_desposit_amount) {
      setHolding_deposit_amount(holdingDepositeData?.holding_desposit_amount);
    }
  }, [
    holdingDepositeData?.openflow_bank_account_id,
    holdingDepositeData?.holding_terms_added,
    holdingDepositeData?.holding_terms,
    holdingDepositeData?.isHoldingDepositSelected,
    holdingDepositeData?.holding_desposit_amount,
    holdingDepositeData?.holding_deposit_collection_from_lead_tenant,
    holdingDepositeData?.collectDeposit,
    modalGlobalObject?.tenants,
    modalGlobalObject?.holding_deposit_collection_from_lead_tenant,
    modalGlobalObject?.open_flow_rental_offer && modalGlobalObject?.open_flow_rental_offer?.rental_amount,
    modalGlobalObject?.open_flow_rental_offer && modalGlobalObject?.open_flow_rental_offer?.tenancy_start_date,
    modalGlobalObject?.open_flow_rental_offer && modalGlobalObject?.open_flow_rental_offer?.rental_frequency,
  ]);

  useEffect(() => {
    if (modalGlobalObject?.payee_ref) {
      setPayeeRef(modalGlobalObject?.payee_ref);
    }
    if (holdingDepositeData?.openflow_bank_account_id) {
      const selectedAccount = bankAccounts?.find((val) => {
        if (val?.openflow_bank_account_id === holdingDepositeData?.openflow_bank_account_id
        ) {
          return val;
        }
      });
      setselectedAccount(selectedAccount);
    }
  }, [
    modalGlobalObject?.payee_ref,
    bankAccounts,
    holdingDepositeData?.openflow_bank_account_id,
  ]);

  const accountDetails = () => (
    <div>
      <>
        <RowContainer>
          <FormContainer>
            <TextInput
              title={'Account Name'}
              value={newAccountName}
              containerStyles={{ width: '100%' }}
              onChange={(e) => setnewAccountName(e.target.value)}
            />
          </FormContainer>
        </RowContainer>
        <RowContainer>
          <FormContainer>
            <Otp
              title={'Sort Code'}
              no={6}
              value={newAccountSortCode}
              containerStyles={{ width: '100%' }}
              onChange={(e) => setnewAccountSortCode(e.target.value)}
            />
          </FormContainer>
          <FormContainer>
            <Otp
              value={newAccountNumber}
              title={'Account Number'}
              no={8}
              containerStyles={{ width: '100%' }}
              onChange={(e) => setnewAccountNumber(e.target.value)}
            />
          </FormContainer>
        </RowContainer>
      </>
      <RowContainer
        style={{
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          marginTop: 10,
        }}
      >
        <Button
          onClick={() => {
            // _onSave(false, false);
            _onAddNewBankAccount()
            setAccountButtonText('Update Account');
          }}
          style={{
            marginTop: '10px',
            borderColor: variables.purple1,
          }}
          title={accountButtonText}
          type="stripe"
        />
      </RowContainer>
    </div>
  );

  const handleRadioChange = (event) => {
    const val = event.target.value === 'true';
    setHoldingDepositCollection(val);
    setcollectDeposit(val);
  };

  const _onSave = (data) => {
    setIsValidated(true);

    let payload = {
      holding_terms_added: holding_terms_added,
      openflow_bank_account_id: data?.account?.openflow_bank_account_id ? data?.account?.openflow_bank_account_id : "",
      tenancy_start_date,
      rental_amount,
      rental_frequency,
      is_holding_deposit_selected: isHoldingDepositSelected,
      payee_ref: data?.payeeRef ? data?.payeeRef : "",
      holding_desposit_amount: holding_amount,
      "account": data?.account?.account_id ? {
        account_id: data?.account?.account_id,
        sort_code: data?.account?.sort_code,
        account_name: data?.account?.account_name,
      } : null,
      holding_deposit_text: holding_terms_added ? holding_terms_added.toString() : "",
      holding_deposit_collection_from_lead_tenant: holdingDepositCollection,
      flow_id: modalGlobalObject?.openflow_id,
      collectDeposit: collectDeposit,
      ...data,
    };

    if (modalGlobalObject?.open_flow_rental_offer?.tenancy_start_date) {
      dispatch(
        tenantActions.saveHoldingDeposit(
          payload,
          modalGlobalObject?.openflow_id,
          null,
          selectedAccount?.openflow_bank_account_id
        )
      );
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      showErrorToast('Please select all mandatory fields')
    }
    setAccountModal(false);
  };
  const isAlreadyRequested = () => {

    const tenants1 = modalGlobalObject?.tenants.filter((tenant) => tenant?.deposit_payment_status == 0);
    console.log("tenants1", tenants1)
    return tenants1.length !== tenants.length;
  }
  const _onAddNewBankAccount = (data) => {

    let payload = {
      "sort_code": newAccountSortCode,
      "account_id": "hub_new",
      "account_name": newAccountName,
      "branch_id": modalGlobalObject?.branch?.name,
      "branch": modalGlobalObject?.branch?.name,
      "swift_code": "",
      "iban": "",
    }

    if (newAccountSortCode && newAccountNumber && newAccountName && modalGlobalObject?.branch?.name) {
      dispatch(tenantActions.saveBankAccount(payload));
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      showErrorToast('Please select all mandatory fields')
    }
    setAccountModal(false);
  };

  const _confirmReceiptAll = () => {
    let arr = [];
    modalGlobalObject?.tenants?.forEach((data) => {
      arr.push(data?.open_flow_sub_tenant_id);
    });

    _confirmReceipt({ flow_id: flowId, open_flow_sub_tenant_id: arr });
  };

  const _confirmReceipt = (data) => {
    dispatch(tenantActions.confirmDeposit(data, flowId));
  };

  const _revokeConfirmReceipt = (data) => {
    dispatch(tenantActions.revokeConfirmationDeposit(data, flowId));
  };

  const requestAllHoldingDeposit = (tenant) => {
    if (!modalGlobalObject?.draft_agreement_url) {
      setShowExecutionCheckModal(true);
      return;
    }

    executeRequestHoldingDeposit(tenant);
  };

  const executeRequestHoldingDeposit = (tenant) => {
    if (tenant?.open_flow_sub_tenant_id) {
      setSelectedTenants([tenant.open_flow_sub_tenant_id]);
    } else {
      setSelectedTenants(modalGlobalObject.tenants.map((t) => t.open_flow_sub_tenant_id));
    }
    setSuccessModal(true);
  };

  const requestAllHoldingDeposit1 = () => {
    TenantService.sendHoldingOffer({
      flow_id: flowId,
      open_flow_sub_tenant_id: selectedTenants,
    }).then((response) => {
      console.log('sendRentalOffer,', response);
      setSuccessModal(false);
      setSelectedTenants([]);
      showSuccesToast('Offer Requested to all Tenants!');
      fetchFlows();
    });
  };

  const getCheckedStatus = () => {
    if (modalGlobalObject?.tenants && modalGlobalObject?.tenants.length) {
      let isChecked = true;
      for (let i = 0; i < modalGlobalObject?.tenants.length; i++) {
        if (modalGlobalObject?.tenants[i]?.deposit_payment_status != 3) {
          isChecked = false;
          break;
        }
      }
      return isChecked;
    }
    return false;
  };

  useEffect(() => {
    if (modalGlobalObject?.open_flow_rental_offer?.rental_frequency && modalGlobalObject?.open_flow_rental_offer?.rental_amount && !holding_amount) {
      // setHolding_deposit_amount(getHoldingDeposite(modalGlobalObject?.open_flow_rental_offer?.rental_amount, modalGlobalObject?.open_flow_rental_offer?.rental_frequency));
    }
  }, [modalGlobalObject?.open_flow_rental_offer?.rental_frequency, modalGlobalObject?.open_flow_rental_offer?.rental_amount, holding_amount]);
  const [showModal2, setShowModal2] = useState(false);
  return (
    <Container>
      <CardWrapper>
        <ProgressCircle props={props} />

        <BackComponent
          id={flowId}
          isComplete={modalGlobalObject?.holding_deposit_status === 1 ? true : false}
          flowtype="holding_deposit_status"
        />
        <CardBox hasShadow hasBorderRadius style={{ position: 'relative', width: '100%' }}>
          <Heading style={{ color: Colors.light.purple }}>Holding Deposit</Heading>
          <SubHeading style={{ marginTop: 0 }}>
            Paying a holding deposit indicates the tenant’s intention to accept the terms and move in on a specified date.
          </SubHeading>
          <HoldingDepositCard
            rental_amount={modalGlobalObject?.open_flow_rental_offer?.rental_amount}
          >
            <View style={{ flexDirection: "column", width: '100%' }}>
              <SubHeading>Will you be requesting holding deposit?</SubHeading>

              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="isHoldingDepositSelected"
                  name="isHoldingDepositSelected"
                  value={isHoldingDepositSelected}
                  onChange={(e) => {
                    if (e?.target?.value === 'true') {
                      setHoldingDepositSelected(true);
                    } else {
                      setHoldingDepositSelected(false);
                    }
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <FormControlLabel
                      value={true}
                      control={<Radio style={{ color: variables.heliotrope }} />}
                      style={{ color: 'black' }}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio style={{ color: variables.heliotrope }} />}
                      style={{ color: 'black' }}
                      label="No"
                    />
                  </div>
                </RadioGroup>
              </FormControl>
              {isHoldingDepositSelected ?
                <>
                  <SubHeading>How would you like to collect the deposit? </SubHeading>
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="holding_deposit_collection_from_lead_tenant"
                      name="holding_deposit_collection_from_lead_tenant"
                      value={holdingDepositCollection}
                      onChange={(e) => {
                        const val = e?.target?.value === 'true';
                        setcollectDeposit(val);
                        setHoldingDepositCollection(val);
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: layoutType == "web" ? 'row' : "column" }}>
                        <FormControlLabel
                          name='holding_deposit_collection_from_lead_tenant'
                          value={true}
                          control={<Radio style={{ color: variables.heliotrope }} />}
                          style={{ color: 'black' }}
                          label="All from lead tenant"
                          checked={holdingDepositCollection === true}
                          onChange={handleRadioChange}
                        />
                        <FormControlLabel
                          name='holding_deposit_collection_from_lead_tenant'
                          value={false}
                          control={<Radio style={{ color: variables.heliotrope }} />}
                          style={{ color: 'black' }}
                          label="Equally between all tenants"
                          checked={holdingDepositCollection === false}
                          onChange={handleRadioChange}
                        />
                      </div>
                    </RadioGroup>
                    <TextInput
                      value={holding_amount}
                      name="holding_amount"
                      onChange={(e) =>{
                        const value = e?.target?.value;
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          setHolding_deposit_amount(value);
                        }
                      }}
                      title={'Holding Deposit amount (£)'}
                      wrapperstyle={{ width: layoutType == 'phone' ? '100%' : '50%' }}
                    />
                  </FormControl>
                </> :
                null}



            </View>
            {isHoldingDepositSelected ? <>


              <div style={{ width: "100%" }}>
                <SubHeading>Holding Deposit Terms </SubHeading>
                <TextBox>{holding_terms}</TextBox>
                <HoldingTerms
                  isVisible={showModal2}
                  onClose={() => setShowModal2(false)}
                />
                <TouchableOpacity
                  onPress={() => setShowModal2(true)}
                  style={{
                    alignItems: 'flex-end',
                    marginTop: 4,
                    paddingVertical: 4,
                  }}
                >
                  <Text style={{
                    color: '#1a73e8',
                    textDecorationLine: 'underline',
                    fontSize: 14,
                    fontWeight: '500',
                  }}>
                    View More
                  </Text>
                </TouchableOpacity>
                <SubHeading>Additional Deposit Terms</SubHeading>
                <TextInput
                  multiline
                  rows={3}
                  value={holding_terms_added || ''}
                  containerstyles={{ height: '90px', padding: 5 }}
                  onChange={(e) => setHoldingTermsAdded(e.target.value)}
                />
              </div>
            </> : null}

            {isHoldingDepositSelected ? <BankAccountComponent
              dataa={{
                payeeRef: payeeRef,
                account: selectedAccount
              }}
              onSave={(data) => {
                console.log("Received in parent:", data);
                _onSave(data)
              }}
            /> :
              null
            }
          </HoldingDepositCard >


          {
            !isHoldingDepositSelected ?
              <TouchableOpacity style={styles.saveButton} onPress={() => {
                _onSave()
              }}>
                <Text style={styles.saveText}>SAVE</Text>
              </TouchableOpacity> : null
          }

        </CardBox>
        <LineSeperator />
        {modalGlobalObject?.tenants && modalGlobalObject?.tenants?.length ? <HoldingStatusTable
          ten={modalGlobalObject.tenants}
          flowId={flowId}
          buttonText={isAlreadyRequested() ? "Request From All" : 'Request again From All'}
          onRightClick={() => {
            requestAllHoldingDeposit(null)
          }}
          holding_amount={holding_amount}
          collectDeposit={collectDeposit}
        /> : null}
      </CardWrapper>

      <div>
        <Dialog
          open={showSuccessModal}
          onClose={() => {
            setSuccessModal(false)
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>


          <DialogContent>
            <DialogContentText sx={{ marginBottom: 10 }}>
              Are you sure, You want to request payment?.
            </DialogContentText>

          </DialogContent>

          <DialogActions>
            <DialogButton onClick={() => {
              requestAllHoldingDeposit1();
            }} color="primary">
              Ok
            </DialogButton>
            <DialogButton onClick={() => {
              setSuccessModal(false)
              setSelectedTenants([]);
            }} color="secondary">
              Cancel
            </DialogButton>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        <Dialog
          open={showExecutionCheckModal}
          onClose={() => setShowExecutionCheckModal(false)}
          aria-labelledby="execution-check-title"
          aria-describedby="execution-check-description"
        >
          <DialogTitle id="execution-check-title" style={{ color: '#265D8C', fontWeight: 700 }}>
            Holding Deposit Request
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="execution-check-description" style={{ color: 'text.secondary', marginBottom: 20 }}>
              To comply with the new legislation you must have sent a draft tenancy agreement, before you can request a holding deposit.
            </DialogContentText>
            <DialogContentText style={{ fontWeight: 600, color: '#555' }}>
              Please go back to the rental offer page and save the rental offer. A Draft tenancy agreement will be automatically sent.
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center', paddingBottom: 20 }}>
            <DialogButton
              onClick={() => setShowExecutionCheckModal(false)}
              color="primary"
              variant="contained"
              style={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 8,
                paddingLeft: 40,
                paddingRight: 40,
                background: '#9b76cfff',
                color: 'white'
              }}
            >
              OK
            </DialogButton>
          </DialogActions>
        </Dialog>
      </div>
      {openAccountModal && (
        <OpenFlowModal
          showModal={openAccountModal}
          setShowModal={setAccountModal}
          modalBody={accountDetails()}
          showFooter={false}
          modalHeading=""
          modalWidth={600}
        />
      )}
    </Container>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    margin: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
    borderWidth: 1,
    borderColor: '#f3f4f6',
  },
  heading: {
    fontSize: 16,
    color: Colors.light.purple,
    fontWeight: '600',
    marginBottom: 12,
  },
  infoBox: {
    flexDirection: 'row',
    backgroundColor: '#e0f2fe',
    padding: 12,
    borderRadius: 8,
    marginBottom: 16,
    flex: 1,
    width: "100%"
  },
  infoIcon: {
    marginRight: 8,
    marginTop: 2,
  },
  infoText: {
    color: '#0e7490',
    fontSize: 13,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
    marginRight: 6
  },
  label: {
    fontWeight: '600',
    marginLeft: 6,
    color: '#6b7280',
  },
  value: {
    marginLeft: 6,
    color: '#6b7280',
  },
  saveButton: {
    marginTop: 28,
    backgroundColor: "#9B59B6",
    paddingVertical: 10,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    width: 200,

  },
  saveText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
  },
});
export default drawerHoc({
  Component: HoldingDeposit,
  showBackButton: true,
  backNavigation:"CurrentOnboards" 
});
